<template>
  <component
    v-bind="$props"
    :is="iconComponent"
    class="inline-block"
    :class="{ 'path-fill-current': !maintainColor }"
    @click="$emit('click', $event)"
  />
</template>

<script>
// import icons from '../../../assets/icons'
const icons = {}
const requireComponents = require.context(
  '../../assets/icons/',
  false,
  /.svg$/,
)

requireComponents.keys().forEach((fileName) => {
  const iconName = fileName.replace(/^\.\/(.+)\.svg$/, '$1')
  const componentConfig = requireComponents(fileName)
  icons[iconName] = componentConfig.default || componentConfig
})

// The following code is runnable on local env, but doesn't work on production
// So we need to manually declare new icons on the `assets/icons/index.js` file.
// Keep it here for reference
// const icons = {}
// const modules = import.meta.glob('../../../assets/icons/*.svg')
// const importPromises = Object.keys(modules).map((file) => {
//   return import(/* @vite-ignore */file)
// })

// Promise.all(importPromises).then((allModules) => {
//   Object.keys(modules).forEach((file, index) => {
//     const iconName = file.replace('../../../assets/icons/', '').replace('.svg', '')
//     icons[iconName] = allModules[index].default
//   })
// })

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    iconClass: {
      type: String,
      default: null,
    },
    maintainColor: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconComponent() {
      return icons[this.name]
    },
  },
}
</script>

<style lang="scss">
svg {
  fill: currentColor;
}
.path-fill-current {
  fill: currentColor;
}
</style>
